import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/attendance/AttendanceAction";
import { redirectToPages, today } from "../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { SectionsPage } from "./sections/SectionsPage";

export function SectionAttendancesPage({
  history
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const [date, setDate] = useState(today);
  
  // Getting curret state of Section Attendances from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type } = useSelector(
    (state) => ({
      actionsLoading: state.attendance.actionsLoading,
      isSuccess: state.attendance.isSuccess,
      type: state.attendance.type
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getTeachersAndDailyCourseHour());
    return () => dispatch(actions.cleanAttendanceState());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Sınıf Yoklamaları";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);
    
  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <>
      <Card>
        { actionsLoading && <ModalProgressBar /> }
        <CardHeader title={title} />
        <CardBody>
          <div className="form-group row">
            <div className="col-2 mt-3">
              Tarih
            </div>
            <div className="col-4">
              <input
                type="date"
                value={date}
                className="form-control"
                max={new Date().toJSON().slice(0, 10)}
                onChange={e => setDate(e.target.value)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <SectionsPage
        history={history}
        date={date}
      />
    </>    
  );
}